import { ICaseStudyByIdMap } from '~/hooks/useCaseStudies';
import { CaseStudy, Pathway, Video } from '~/types';
import compareByLocation from '~/utils/pathway/compareByLocation';
import { toBoolean } from '~/utils/toBoolean';

interface VideoWithLocation extends Video {
  location: number;
}

export interface IPathwayWithCaseStudy extends Pathway {
  items: (VideoWithLocation | CaseStudy)[];
}

const bindCaseStudiesToPathway =
  (caseStudiesByPathwayIdMap: ICaseStudyByIdMap) =>
  (pathway: Pathway): IPathwayWithCaseStudy => {
    const videos =
      pathway?.videos?.filter(toBoolean<Video>).map((video, index) => ({
        ...video,
        location: index + 1,
      })) || [];
    const caseStudy = caseStudiesByPathwayIdMap[Number(pathway?.id)];
    return {
      ...pathway,
      items: caseStudy?.length
        ? [...videos, ...caseStudiesByPathwayIdMap[Number(pathway?.id)]].sort(compareByLocation)
        : videos,
    };
  };

export default bindCaseStudiesToPathway;
